<template>
  <v-col>
    <v-row>
      <v-col>

        <h1>Movimenti</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        lg="4"
      >
        <v-card>
          <v-card-text class="primary--text">Entrate</v-card-text>
          <v-card-title>{{ entrate }} €</v-card-title>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <v-card>
          <v-card-text class="primary--text">Uscite</v-card-text>
          <v-card-title>{{ uscite }} €</v-card-title>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        lg="4"
      >
        <v-card>
          <v-card-text class="primary--text">Rapporto</v-card-text>
          <v-card-title>{{ (entrate - uscite).toFixed(2) }} €</v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        xl="9"
        class="order-last order-xl-first"
      >
        <v-row>
          <v-col class="py-0">
            <v-card style="width: 100%">
              <v-card-title class="pb-8">
                <v-btn
                  color="primary"
                  @click="CHANGE_MOVIMENTI_COMPONENT('Insert')"
                >Nuovo Movimento</v-btn>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Cerca"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="filteredMovements"
                class="elevation-1"
                :search="search"
                :items-per-page="100"
                :footer-props="{
									itemsPerPageAllText: 'Tutti',
									itemsPerPageOptions: [15, 50, 100, -1],
									itemsPerPageText: 'Movimenti per pagina',
								}"
              >
                <template v-slot:top>
                  <edit-form
                    :item="selectedItem"
                    :categories="categories"
                    @edit-submit="triggerSnack($event)"
                  />
                </template>

                <template v-slot:item.kind="{ header, item }">
                  <span
                    v-if="item.kind == 'entrata'"
                    class="success--text font-weight-bold"
                  >{{
										item.kind[0].toUpperCase() + item.kind.substr(1)
									}}</span>
                  <span
                    v-else-if="item.kind == 'uscita'"
                    class="error--text font-weight-bold"
                  >{{
										item.kind[0].toUpperCase() + item.kind.substr(1)
									}}</span>
                </template>

                <template v-slot:item.price="{ header, item }">
                  {{ item.amount }}€
                </template>

                <template v-slot:item.action="{ item }">
                  <td class="actions">
                    <v-btn
                      color="orange"
                      elevation="1"
                      outlined
                      small
                      @click.stop="edit(item)"
                    >
                      <v-icon small>
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                    <v-btn
                      color="red"
                      elevation="1"
                      outlined
                      small
                      @click.stop="triggerDialog(item)"
                    >
                      <v-icon small>
                        mdi-delete
                      </v-icon>
                    </v-btn>
                  </td>
                </template>

                <template v-slot:no-data>
                  <v-btn
                    color="primary"
                    @click="fetchMovements"
                  >Ricarica</v-btn>
                </template>

                <template v-slot:item.price="{ item }">
                  <span>{{ item.price.toFixed(2) || '0.00' }}€</span>
                </template>

                <template v-slot:item.posix="{ item }">
                  <span>{{
										new Date(item.posix).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric' })
									}}</span>
                </template>
              </v-data-table>
              <snack-notification :snack="snack" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col>
        <filters
          :categories="categories"
          v-on:filters-changed="filterMovements"
        />
      </v-col>
    </v-row>

    <!-- dialog -->

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Cancellare movimento?</v-card-title>

          <v-card-text>
            Confermando, il movimento selezionato verrà eliminato dal magazzino.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="remove()"
            >
              Conferma
            </v-btn>

            <v-btn
              color="primary"
              @click="dialog = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapActions, mapGetters } from 'vuex'

  import EditForm from './EditForm'
  import SnackNotification from './../SnackNotification'
  import Filters from './Filters.vue'

  export default {
    name: 'Index',
    components: {
      EditForm,
      SnackNotification,
      Filters,
    },
    data: () => ({
      search: '',
      dialog: false,
      headers: [
        { text: 'Tipo', value: 'kind', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Categoria', value: 'category.title', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Valore', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Data', value: 'posix', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Descrizione', value: 'description', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: false },
      ],
      movements: [],
      filteredMovements: [],
      categories: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null,
      },
      config: {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
        },
      },
    }),

    computed: {
      ...mapGetters(['getFiltriMovimenti']),
      selectedItem() {
        return this.item
      },
      article() {
        return this.row
      },
      entrate() {
        if (this.filteredMovements.length === 0) return '0.00'

        let tot = 0

        this.filteredMovements.map((el) => {
          if (el.kind == 'entrata') {
            tot += el.price
          }
        })

        return tot.toFixed(2)
      },
      uscite() {
        if (this.filteredMovements.length === 0) return '0.00'

        let tot = 0

        this.filteredMovements.map((el) => {
          if (el.kind == 'uscita') {
            tot += el.price
          }
        })

        return tot.toFixed(2)
      },
    },

    methods: {
      ...mapMutations(['CHANGE_MOVIMENTI_COMPONENT', 'CHANGE_MOVIMENTI_EDIT']),

      ...mapActions(['delete_movement']),

      async fetchMovements() {
        try {
          let { data } = await axios.get(`${process.env.VUE_APP_API}/movements/fetch`, this.config)

          this.movements = data
          this.filterMovements()
        } catch (error) {
          console.log(error)

          this.movements = []
        }
      },

      async fetchCategories() {
        try {
          let { data } = await axios.post(
            `${process.env.VUE_APP_API}/categories/by-reference`,
            { reference: 'movimenti' },
            this.config
          )

          this.categories = data
        } catch (error) {
          console.log(error)

          this.categories = []
        }
      },

      edit(val) {
        this.item = val
        this.CHANGE_MOVIMENTI_EDIT(true)
      },

      triggerDialog(val) {
        this.item = val
        this.dialog = true
      },

      async remove() {
        try {
          await this.delete_movement(this.item)

          this.snack = Object.assign(
            {},
            {
              visible: true,
              error: false,
              message: 'Movimento eleminato correttamente!',
            }
          )

          this.fetchMovements()
          this.dialog = false
        } catch (error) {
          this.snack = Object.assign(
            {},
            {
              visible: true,
              error: true,
              message: "Errore nell'eliminazione.",
            }
          )
        }
      },

      triggerSnack(e) {
        if (e === 'reset') {
          this.snack = Object.assign(
            {},
            {
              error: null,
              visible: null,
              message: null,
            }
          )
        } else if (e === 'ok') {
          this.snack = Object.assign(
            {},
            {
              visible: true,
              error: false,
              message: 'Movimento modificato correttamente!',
            }
          )

          this.fetchMovements()
        } else if (e === 'error') {
          this.snack = Object.assign(
            {},
            {
              visible: true,
              error: true,
              message: 'Errore nella modifica.',
            }
          )
        }
      },

      filterMovements() {
        let filtered = this.movements

        filtered = filtered.filter(
          (el) =>
            new Date(el.posix).getTime() / 1000 >= new Date(this.getFiltriMovimenti.from).getTime() / 1000 &&
            new Date(el.posix).getTime() / 1000 <= new Date(this.getFiltriMovimenti.to).getTime() / 1000
        )

        if (!!this.getFiltriMovimenti.kind) {
          filtered = filtered.filter((el) => el.kind === this.getFiltriMovimenti.kind)
        }

        if (!!this.getFiltriMovimenti.category_id) {
          console.log(this.getFiltriMovimenti.category_id)
          filtered = filtered.filter((el) => el.category_id === this.getFiltriMovimenti.category_id)
        }

        this.filteredMovements = filtered
      },
    },

    async created() {
      await this.fetchMovements()
      await this.fetchCategories()
    },
  }
</script>

<style>
  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>
